import { entityRouteRef } from '@backstage/plugin-catalog-react';
import { useRouteRefParams } from '@backstage/frontend-plugin-api';
import { RulesContextProvider } from '../Providers';
import { ComplianceTab } from '../CatalogTabs';

/**
 * The merged Compliance tab (Finance + Security + Housekeeping), replacing
 * the three per-category rule tabs — see design/compliance-page-mockup.html.
 */
export const AccountComplianceTab = () => {
  const { name } = useRouteRefParams(entityRouteRef);

  return (
    <RulesContextProvider accountName={name}>
      <ComplianceTab />
    </RulesContextProvider>
  );
};
